import { render, staticRenderFns } from "./failed.vue?vue&type=template&id=fe829368"
import script from "./failed.vue?vue&type=script&lang=js"
export * from "./failed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\web\\rcms\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe829368')) {
      api.createRecord('fe829368', component.options)
    } else {
      api.reload('fe829368', component.options)
    }
    module.hot.accept("./failed.vue?vue&type=template&id=fe829368", function () {
      api.rerender('fe829368', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/callback/failed.vue"
export default component.exports